import YahooImg from "./assets/images/nbaShotChart.gif";
import UVPGif from "./assets/images/uvpGif.gif";
import adkGif from "./assets/images/adkExpGif.gif";
import PandemicPandemonium from "./assets/images/pandemicPandemonium.png";
import ForcesJpg from "./assets/images/forces.jpg";

import SonnyBeachPhoto from "./assets/images/sonnyBeachPhoto.webp";
import SonnyBeachPhoto2 from "./assets/images/sonnyBeachPhoto2.webp";

import SonnySunsetPhoto1 from "./assets/images/sunsetSonny1.webp";
import SonnySunsetPhoto2 from "./assets/images/sunsetSonny2.webp";

import StoryTeller from "./assets/images/storyteller.jpg";
import BasektballByStateImg from "./assets/images/75Img.jpg";
import Bridgerton from "./assets/images/Bridgerton.jpeg";
import Dome from "./assets/images/dome2.jpeg";
import MosEspa from "./assets/images/mosEspa.jpeg";
import ObjectsWeKeep from "./assets/images/ObjectsWeKeep.jpg";
import SlotMachine from "./assets/images/slotMachine.jpg";
import PriceIsRight from "./assets/images/PriceIsRight.jpeg";
import ChickenSandwich from "./assets/images/chickenSandwich.jpeg";
import Courtyard from "./assets/images/courtyard.jpeg";
import ShotChard3D from "./assets/images/nbaShotChart.gif";
import spjIcon from "./assets/images/spjlogo-for-header.png";
import eppyLogo from "./assets/images/eppyLogo.png";
import acpLogo from "./assets/images/acpLogo.jpeg";
import beaLogo from "./assets/images/beaLogo.jpeg";
import hearstLogo from "./assets/images/hearstLogo.png";
import sndLogo from "./assets/images/sndLogo.png";
import blenderLogo from "./assets/images/Blender_logo.png";
import babylonLogo from "./assets/images/logo-babylonjs.png";
import typescriptLogo from "./assets/images/typescript.png";
import reactLogo from "./assets/images/react.png";
import realityCaptureLogo from "./assets/images/realityCaptureLogo.png";
import aframeLogo from "./assets/images/aframe-logo.png";
import lensStudioLogo from "./assets/images/lensStudioLogo.png";
import sparkLogo from "./assets/images/sparkArLogo.webp";
import unityLogo from "./assets/images/unityLogo.png";
import unrealLogo from "./assets/images/unrealLogo.png";
import cornellHempPreviewGif from "./assets/images/CornellHempPreviewGifOptimized.gif";
import storySplatImage from "./assets/images/story-splat.png";
import ToiletImg from "./assets/images/toilet.png";
import MediaLitImg from "./assets/images/mediaLit.png";
import peabodyAward from "./assets/images/peabodyAward.svg";
import cvcheGif from "./assets/images/cvcheGif.gif";

const logotext = "SC";
const meta = {
  title: "Sonny Cirasuolo",
  description:
    "I’m Sonny Cirasuolo, an XR Engineer and Creative Technologist. I build live stadium AR at ARound, founded StorySplat, and have shipped immersive work for Yahoo, The New Yorker, and NOWHERE.",
};

const introdata = {
  title: "I’m Sonny Cirasuolo",
  animated: {
    subfirst: "I’m a software engineer and creative technologist.",
    first: "I create immersive experiences",
    second: "I develop web apps",
    third: "I design games",
    fourth: "I connect people",
    fifth: "I build worlds",
    sixth: "I craft 3D environments in Blender",
    seventh: "I write code",
    eighth: "I do photogrammetry",
  },
  description:
    "I am an XR Engineer at ARound, Founder of StorySplat, and an award-winning creative technologist. I’ve shipped immersive experiences for Yahoo Sports, The New Yorker, and NOWHERE, and I build the AR, 3D, and web tools that bring audiences into the story.",
  your_img_url: SonnySunsetPhoto1,
  your_img_url2: SonnySunsetPhoto2,
  your_img_urlLight: SonnyBeachPhoto,
  your_img_url2Light: SonnyBeachPhoto2,
};

const dataabout = {
  title: "About me",
  aboutme:
    "I am an award-winning immersive media producer, creative technologist, and software engineer. I've shipped work for Yahoo Sports, The New Yorker, NOWHERE, and ARound, and I founded StorySplat. I create beautiful 3D environments and write the code that lets people connect with others inside of them.",
  aboutme2:
    "Learn more about my story through an article written about me on Syracuse University's website: ",
  aboutme2LinkText: "Storytelling in New Dimensions",
  aboutme2Link:
    "https://www.syracuse.edu/stories/sonny-cirasuolo-newhouse-virtual-reality/",
};
const worktimeline = [
  {
    jobtitle: "XR Engineer",
    where: "ARound (Stagwell)",
    date: "2025 - Present",
  },
  {
    jobtitle: "Founder & Sole Developer",
    where: "StorySplat",
    date: "2024 - Present",
  },
  {
    jobtitle: "Immersive Story Developer",
    where: "The New Yorker",
    date: "2024",
  },
  {
    jobtitle: "Creative Technologist & XR Engineer",
    where: "NOWHERE",
    date: "2022 - 2024",
  },
  {
    jobtitle: "Augmented Reality and Video Producer",
    where: "Yahoo Sports",
    date: "2021 - 2022",
  },
  {
    jobtitle: "VR Experience Lead & Research Assistant",
    where: "Syracuse University",
    date: "2020 - Present",
  },
];

const skills = [
  {
    name: "Blender",
    image: blenderLogo,
  },
  {
    name: "Babylon.js",
    image: babylonLogo,
  },
  {
    name: "TypeScript",
    image: typescriptLogo,
  },
  {
    name: "React",
    image: reactLogo,
  },
  {
    name: "Reality Capture",
    image: realityCaptureLogo,
  },
  {
    name: "Aframe",
    image: aframeLogo,
  },
  {
    name: "Snap Lens Studio",
    image: lensStudioLogo,
  },
  {
    name: "Spark AR Studio",
    image: sparkLogo,
  },
  {
    name: "Unreal Engine",
    image: unrealLogo,
  },
  {
    name: "Unity",
    image: unityLogo,
  },
];

const services = [
  {
    title: "Web Development",
    description:
      "I can develop web apps for your business or organization. I have experience developing web apps using React, Typescript, node.js , and Babylon.js. I can also develop static websites using HTML, CSS, and Javascript.",
  },
  {
    title: "AR & VR Development",
    description:
      "I have extensive experience in developing immersive experiences using AR and VR technologies. I have worked on several projects that involve creating 3D environments, integrating real-world objects with virtual objects, and developing interactive experiences that engage users in new and exciting ways.",
  },
  {
    title: "Photogrammetry",
    description:
      "I can create photorealistic 3D models of real world objects and places to fit the needs of any 3D pipeline.",
  },
  {
    title: "3D Model Optimization",
    description:
      "I am an expert in optimizing 3D models for use in web based applications. I can optimize your 3D models to fit the needs of your project and have ample experience delivering scenes and models that can be easily viewed with a web browser on any device.",
  },
  {
    title: "Immersive Media Consulting",
    description:
      "I can help you develop a plan to integrate immersive media into your platform, and help you find the right tools and people to make your vision a reality.",
  },
  {
    title: "Immersive Tours",
    description:
"I can create immersive tours of real world places that can be viewed on any device, bringing the audience into the space and allowing them to explore freely without being there physically.",
  },
];

const yahooData = {
  date: "May 2021- June 2022",
  title: "Yahoo Sports",
  description:
    "These are the augmented reality pieces that I worked on while employed by Yahoo Sports. Our goal was to bridge the gap between immersive media and sports media, and we were pioneers in that field. Through the use of internal tools and external tools such as Spark AR and Blender, we created augmented reality effects that any sports fan would love. I also helped produce projects for Yahoo News, Life and Entertainment. ",
  mainButtonText: "Yahoo Author Page",
  slideImages: [
    {
      url: ShotChard3D,
      caption: "3D Shot Charts",
    },
    {
      url: Dome,
      caption: "Lars Homestead Dome Photogrammetry",
      link: "https://cdn.launch3d.com/cu/xr/production-editorial/index.html?customJsonPath=https://prod-immersive-composer-published-experiences.s3.amazonaws.com/experiences/94337f48-84de-47fa-b58d-ae13a0bb65ab/v1/web/index.json",
    },
    {
      url: Courtyard,
      caption: "Lars Homestead Courtyard Photogrammetry",
      link: "https://cdn.launch3d.com/cu/xr/production-editorial/index.html?customJsonPath=https://prod-immersive-composer-published-experiences.s3.amazonaws.com/experiences/ca9dcb21-ea04-4529-a31b-6c1402041560/v1/web/index.json",
    },
    {
      url: ChickenSandwich,
      caption: "Chicken Sandwich Photogrammetry",
      link: "https://cdn.launch3d.com/cu/xr/rc/index.html?customJsonPath=https://cdn.launch3d.com/cy/composer/prod/editorial/9be51108-d01e-47f8-81bb-feed50e545d9/v2/web/index.json&mode=3d",
    },
    {
      url: PriceIsRight,
      caption: "Price is Right Wheel",
    },
    {
      url: SlotMachine,
      caption: "Random March Madness Slot Machine",
      link: "https://cdn.launch3d.com/cu/xr/rc/index.html?lang=en-US&mode=object&selectedObjectIndex=0&site=frontpage&slug=womens-mm-slot-machine-151346308&spaceid=2023538075&customJsonPath=https://cdn.launch3d.com/cy/composer/prod/editorial/f398b818-6640-4a9b-acb6-138e2df47f65/v1/web/index.json",
    },
    {
      url: ObjectsWeKeep,
      caption: "Objects We Keep",
      link: "https://cdn.launch3d.com/cu/xr/production-editorial/index.html?customJsonPath=https://cdn.launch3d.com/cy/composer/prod/editorial/474107ef-d08c-4f97-8ede-cc7f07a58bd7/v8/web/index.json&mode=3d",
    },
    {
      url: MosEspa,
      caption: "Mos Espa Photogrammetry",
      link: "https://cdn.launch3d.com/cu/xr/production-editorial/index.html?customJsonPath=https://prod-immersive-composer-published-experiences.s3.amazonaws.com/experiences/19e84511-1ce8-4ef7-aa1d-6f780be5c006/v1/web/index.json",
    },
    {
      url: Bridgerton,
      caption: "Bridgerton Photogrammetry",
      link: "https://cdn.launch3d.com/cu/xr/production-editorial/index.html?customJsonPath=https://cdn.launch3d.com/cy/composer/prod/editorial/cbc9dfbf-6edd-4f1d-a3c7-b200a92dcb6a/v0/web/index.json&mode=3d",
    },
    {
      url: StoryTeller,
      caption: "Storyteller Photogrammetry",
    },
    {
      url: BasektballByStateImg,
      caption: "Basketball by State 3D stats",
    },
  ],
};

const yahooData2 = {
  title: "Yahoo Projects",
  date: "May 2021- June 2022",
  slideImages: [
    {
      iframe: "https://www.youtube.com/embed/XxayKY4zRvA?si=_ddQ7xdCp9MfNTvC",
      title: "Running Back Record",
    },
    {
      iframe:"https://www.youtube.com/embed/UjjOp8mKs58?si=6jvIh1pX5XnkVUvN",
      title: "Baseball Card Grading Game",
    },
    {
      iframe: "https://www.youtube.com/embed/N0xww0_XM-Y?si=85eEXhg2V90Fbzz-",
      title: "Baseball Signs Game",
    },
    {
      iframe: "https://www.youtube.com/embed/nuDynkYxsP4?si=I1-FbTj6nyom88xF",
      title: "Star Wars - Lars Homestead Dome",
    },
    {
      iframe: "https://www.youtube.com/embed/G4k7Ovt8MgE?si=hit8gt9ejgDjN_pj",
      title: "Star Wars - Lars Homestead Courtyard",
    },
    {
      iframe: "https://www.youtube.com/embed/QRzJfG_FUwA?si=wNwnQVA8eA4exEiA",
      title: "Star Wars - Mos Espa",
    },
    {
      iframe: "https://www.youtube.com/embed/S49p71eC2ok?si=b7VnA2ewRjqNsqST",
      title: "Price is Right Wheel"
    },
    {
      iframe: "https://www.youtube.com/embed/d4YXZrT8SvM?si=4jGFR14iKW-BGke-&amp;controls=0",
      title: "Harden Simmons 3D Shot Chart",
    },
    {
      iframe: "https://www.youtube.com/embed/0wOaqCDBQ2U?si=g26txrU781RJf6LO",
      title: "Where Are The Top 75 NBA Players From?"
    },
    {
      iframe: "https://www.youtube.com/embed/StXpdunXzQw?si=hhKSvJibdZ6-xvSA" ,
      title: "NFL Trophy Case",
    },
    {
      iframe: "https://www.youtube.com/embed/ur-zEkG98bw?si=Ezh4eviFBM73pACK",
      title: "Why Is Curling Ice Bumpy?"
    },
    {
      iframe: "https://www.youtube.com/embed/iE1n2slke_s?si=KebH24WXgMlsCIfm",
      title: "Why Does A Curling Stone Curl?"
    },
    {
      iframe: "https://www.youtube.com/embed/J2hc5Zh4x6U?si=9d7JTE03dpPWiVOh",
      title: "What Does Sweeping Do In Curling?"
    },
    {
      iframe: "https://www.youtube.com/embed/5OtN-XL9M9M?si=VaovVzzblZttD7E4",
      title: "Curling Stone Basics"
    },
    {
      iframe: "https://www.youtube.com/embed/mL5bCLww91E?si=wtdIAVOirEGXNVm8",
      title: "Ukraine Conflict Map"
    },
    {
      iframe: "https://www.youtube.com/embed/jnbf75xzcGM?si=ygWphuKajJCrA35f",
      title: "Where Are the January 6th Rioters Now?"
    },
    {
      iframe: "https://www.youtube.com/embed/9LJjOyDNAWM?si=scP3-0IzIb0uW5HV",
      title: "Top 10 US Winter Olympians by Medal Count"
    },
    {
      iframe: "https://www.youtube.com/embed/8lj4gXvHctg?si=7FI4eF7GeMine7FD",
      title: "Championship Trophies"
    },
    {
      iframe: "https://www.youtube.com/embed/ENS96UsD7Qg?si=H4o2DZVD7F5t-feo",
      title: "MLB Roster Payroll Breakdown"
    }
  ]
  }


const gaussianSplatData = {
  title: "Gaussian Splats",
  slideImages: [
    {
      iframe:
        "https://lumalabs.ai/embed/40a86b95-a917-4b61-bd1a-4f3ac33ca7d7?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Pegasus, Bolbi Gardens",
    },
    {
      iframe: "https://lumalabs.ai/embed/50573552-c5f0-4609-9d4d-aa382cc11ee7?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Alexander the Great, Parthenon Museum, Athens",
    },
    {
      iframe: "https://lumalabs.ai/embed/31f8ca74-4fe2-4a2f-8118-71fde2c33c9d?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Bolbi Garden Statue",
    },
    {
      iframe: "https://lumalabs.ai/embed/660b0ed8-de6a-4247-b4f3-b2195f70e417?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Bolbi Gardens Mask",
    },
    {
      iframe: 'https://lumalabs.ai/embed/4bf5a3fe-3dcc-463a-957f-05e197e353de?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false',
      title: 'Statue, Piti Palace',
    },
    {
      iframe: "https://lumalabs.ai/embed/199a4522-1e58-444e-97d3-4fa2bf46621c?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Statue 2, Piti Palace",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/e172be2d-97f4-4d2b-929b-d6dfaa62e8a0?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Michelangelo Sculpture, Florence Duomo Museum",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/d5021c0d-eae6-49db-89e5-0768eb490f07?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Donatello Sculpture, Florence Duomo Museum",
    },
    {
      iframe: "https://lumalabs.ai/embed/fcfd058e-3211-4c41-a564-1eb8d039d42d?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Statue, Florence along the Arno",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/5a039e92-5956-41a4-bc6f-f11ea049b9cf?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Sarcophagus, Florence Duomo Museum",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/1d2faddf-488b-4597-b47a-5d3d5ea23f71?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Santa Maria Novella, Florence",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/f56016a2-6957-402a-99c2-110df80d5399?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Gravestone, Florence Duomo Reparata",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/988b1834-dc1a-4d6b-9c10-04af5d512d23?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Florence Duomo Tower Bell",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/729e0ff8-edca-4e82-8a0e-8a307cb818d6?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Uffizi Statue 1",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/b1be9424-d177-4c6e-8c3b-862a0ecea5c4?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Uffizi Statue 2",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/d68e6d05-04e9-433f-b6c3-885a52057c05?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Uffizi Statue 3",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/9c5be618-5858-4723-ac1d-5f38d2011abe?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Uffizi Statue 4",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/f6126693-284c-4934-b741-44461984eb3b?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Uffizi Painting",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/0fee3747-a4a3-4ef7-af1b-e4d0bc8cad8e?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Sculpture of Da Vinci, Florence Duomo Museum",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/162e7d35-d5d6-4cb9-be60-f92c2a4bf170?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Crouching Venus, British Museum",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/b021ca3d-3ff4-4f06-90fb-6c9810194e1f?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Trentham Laver, British Museum",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/42b68b84-6ba4-4da8-983d-97e7bea5c6ba?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Pumpkin Patch",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/827d56bd-9ed8-4abe-a1d6-3212ab90af99?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Jaleel's Room",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/7aa90816-bd35-4f04-92e5-28112a9366fa?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Jersey Shore House",
    },
    {
      iframe:
        "https://lumalabs.ai/embed/ca7c5e3b-0920-4425-a8ec-78d6b18a3aa3?mode=sparkles&background=%23ffffff&color=%23000000&showTitle=true&loadBg=true&logoPosition=bottom-left&infoPosition=bottom-right&cinematicVideo=undefined&showMenu=false",
      title: "Christmas Tree 2023",
    },
  ],
};

const vis81Data = {
  date: "May 2021",
  title: "Visualizing 81",
  description:
    "Visualizing 81 is a look at the past, present and future of the city of Syracuse and how Interstate 81 has impacted the historic 15th ward. Through the use of photogrammetry, Aframe, 360 imagery and other WebXR tools our team was able to bring the audience on a voyage through history.",
  mainButtonText: "Visit Visualizing 81",
  link: "https://visualizing81.thenewshouse.com",
  slideImages: [
    {
      iframe: "https://i81360s.netlify.app/almondatharrisonfadenew",
    },
    {
      iframe: "https://i81360s.netlify.app/amezionfadenew",
    },
    {
      iframe: "https://i81360s.netlify.app/pioneerhomesboysfadenew",
    },

    {
      iframe: "https://i81360s.netlify.app/girlsonfencefadenew",
    },
    /* 
      {
      iframe: "https://i81360s.netlify.app/auntedithsfadenew",
    },
   {
      iframe: "https://i81360s.netlify.app/irvingatfayettefadenew",
    },
    {
      iframe: "https://i81360s.netlify.app/mlkfadenew",
    },

    {
      iframe: "https://i81360s.netlify.app/pioneerhomesfadenew",
    },
    {
      iframe: "https://i81360s.netlify.app/wilsonparkfadenew",
    },
    {
      iframe: "https://i81360s.netlify.app/irvinglot",
    },
    {
      iframe: "https://i81360s.netlify.app/fayettecorner",
    },
    {
      iframe: "https://i81360s.netlify.app/almondatadamsfadenew",
    },
 */
  ],
  awards: [
    {
      logo: spjIcon,
      title: "Society of Professional Journalists",
      caption:
        "Mark of Excellence Regional Winner -Immersion Journalism & Best Use of Multimedia 2022",
      link: "https://www.spj.org/news.asp?REF=1864#:~:text=Platforms%0A%0AImmersion%20Journalism-,Winner%3A%20Visualizing%2081%20%E2%80%94%20by%20staff%20of%20The%20NewsHouse%2C%20Syracuse%20University,-Finalist%3A%20Live%20oaks",
    },
    {
      logo: acpLogo,
      title: "Associated Collegiate Press",
      caption: "1st Place -Multimedia News Story of the Year",
      link: "https://studentpress.org/acp/2021-multimedia-story-of-the-year/",
    },
    {
      logo: eppyLogo,
      title: "EPPY Awards",
      caption: "Best college/university produced community or niche website:",
      link: "https://www.eppyawards.com/#:~:text=Best%20college/university%20produced%20community%20or%20niche%20website%3A",
    },
    {
      logo: beaLogo,
      title: "The Broadcast Education Association",
      caption: "Award of Excellence - Interactive Multimedia 2021",
      link: "https://www.beaweb.org/OL/2021-creative-competition-winners#:~:text=Visualizing%2081%20%E2%80%94%20Sonny%20Cirasuolo%2C%20Lawry%20Boyer%2C%20Kevin%20Camelo%2C%20Molly%20Gibbs%20and%20Amanda%20Paule%2C%20Syracuse%20University",
    },
    {
      logo: hearstLogo,
      title: "Hearst Awards",
      caption:
        "2nd place - Hearst Team Multimedia Digital News or Enterprise Story",
      link: "https://www.hearstawards.org/competitions/multimedia/2021-22/#:~:text=Boyer%2C%0AMolly%20Gibbs-,Second%20Place,-Syracuse%20University%0A%242%2C000",
    },
    {
      logo: sndLogo,
      title: "Society for News Design",
      caption: "Award of Excellence - Experimental Design",
      link: "https://snd.org/best-of-design-competitions/2020-best-of-digital-design-results/",
    },
  ],
};
const dataportfolio = [
  {
    title: "XRGallery",
    description:
      "I created XRGallery — a production-ready platform for building immersive 360 VR experiences with geographic navigation, interactive hotspots, AI-powered image generation, and a professional content management dashboard. Built with Babylon.js, TypeScript, and WebXR.",
    iframe: "https://www.xrgallery.online/vJpsWl5HToyZVT6J5R8k?embed=true",
    link: "https://www.xrgallery.online/vJpsWl5HToyZVT6J5R8k",
    buttonName: "View Tour",
  },
  {
    title: "StorySplat",
    description:
      "StorySplat is a no-code, visual editor designed for storytellers and journalists to easily create immersive fly-through experiences using Gaussian splats.",
    img: storySplatImage,
    buttonName: "StorySplat.com",
    link: "https://storysplat.com/",
  },
  {
    title: "CVCHE",
    description:
      "Experience CVCHE, a web based audio experience. One Album, 10 songs, 10 Levels. Can you make it to the end?",
    img: cvcheGif,
    link: "https://heycvche.com",
    buttonName: "Play CVCHE",
  },
  {
    title: "Billion Dollar Toilet",
    link: "https://billiondollartoilet.com/",
    description:
      "Dump your meme coins into the Billion Dollar Toilet, get roasted by Flushy and dedicate that shit to someone or something that inspires you. Join the movement.",
    img: ToiletImg,
    buttonName: "Dump Shit Coins",
  },
  {
    title: "Cleared By Fire",
    link: "https://www.newyorker.com/podcast/in-the-dark/cleared-by-fire",
    description:
      "A Peabody Award–winning piece. On November 19, 2005, a group of U.S. Marines killed twenty-four civilians in Haditha, Iraq. The incident led to one of the most high-profile war-crimes prosecutions in American history. But no one was ever held accountable for the killings. An interactive documentary reconstructs the events of that day to understand what really happened.",
    iframe: "https://www.youtube.com/embed/XG5O736-g3c?si=EKIDqP1vsjc1ERw-",
    badge: peabodyAward,
    badgeAlt: "Peabody Award Winner",
    badgeLink: "https://peabodyawards.com/award-profile/cleared-by-fire/",
    buttonName: "Explore the Interactive",
  },
  {
    title: "Hidden Realities — AR Magic in Hospitals",
    video:
      "https://firebasestorage.googleapis.com/v0/b/cloud-storage-438903.firebasestorage.app/o/hiddenrealities%2FHFM_Promo%201080%20Fixed.mp4?alt=media&token=25ffcaaa-fbd3-45ab-b9b3-302527f63547",
    aspectRatio: "16 / 9",
    description:
      "Hidden Realities brings the magic of augmented reality to hospitals, creating moments of wonder and comfort for patients. This project blends immersive AR experiences with healthcare to transform the patient experience.",
    link: "https://www.ourhiddenrealities.com/",
    buttonName: "Visit Hidden Realities",
  },
  {
    title: "NOWHERE",
    link: "/nowhere",
    description:
      "NOWHERE was a groundbreaking virtual world platform combining immersive 3D environments with real-time video communication. As an XR Engineer, I helped build experiences that pushed the boundaries of browser-based virtual worlds.",
    img: "https://img.youtube.com/vi/nQUrD1YdVok/maxresdefault.jpg",
    buttonName: "View Project",
    internalPage: true,
  },
  {
    title: "Media Literacy in the Metaverse",
    img: MediaLitImg,
    buttonName: "Research in Progress",
    description: "Developed for Syracuse University, this Unity VR experience simulates how misinformation spreads in the metaverse and teaches people how to identify it. It is currently being used at the Newhouse research lab as part of a DHS grant-funded study.",
  },
  {
    title: "Unity Web Controller",
    img: UVPGif,
    description:
      "I developed the web controller for this interactive installation. The web client allows users to control the unity client over a websocket using their mobile devices.",
    link: "https://www.lightwork.org/archive/evan-starling-davis-fracture/",
    gitRepo: "https://github.com/SonnyC56/unity-web-controller-template",
  },
  {
    title: "Yahoo",
    img: YahooImg,
    description:
      "These are the augmented reality pieces that I worked on while employed by Yahoo Sports. Our goal was to bridge the gap between immersive media and sports media, and we were pioneers in that field. Through the use of internal tools and external tools such as Spark AR and Blender, we created augmented reality effects that any sports fan would love. I also helped produce projects for Yahoo News, Life and Entertainment. ",
    link: "/yahoo",
    buttonName: "Explore Yahoo Projects",
    internalPage: true,
  },
  {
    title: "Visualizing 81",
    iframe: "https://i81360s.netlify.app/auntedithsfadenew",
    iframeBg: "#ffffff",
    aspectRatio: "16 / 9",
    description:
      "Visualizing 81 is a look at the past, present and future of the city of Syracuse and how Interstate 81 has impacted the historic 15th ward. Through the use of photogrammetry, Aframe, 360 imagery and other WebXR tools our team was able to bring the audience on a voyage through history.",
    link: "/vis81",
    buttonName: "View Project",
  },
  {
    title: "Photogrammetry Portfolio",
    iframe:
      "https://sketchfab.com/models/3b7c2f6e2f164d18b6865953b2d88ef1/embed?autospin=1&autostart=1&preload=1",
    description:
      "Photogrammetry is the process of creating photorealistic, to scale 3D models of real world objects which can then be shared with your audience. Photogrammetry has enormous potential to change the game when it comes to immersive storytelling and advertising campaigns. Tied together with WebXR and Augmented Reality platforms, photogrammetry is a way to bring an object or place into the audiences space and immerse them like never before.",
    link: "https://sketchfab.com/sonnycirasuolo/collections/portfolio-pieces-c6422cace098463ba4159393cdec0ec0",
    buttonName: "View 3D Portfolio",
  },
  {
    title: "Gaussian Splats",
    iframe:
      "https://cdn-luma.com/public/lumalabs.ai/viewers/sparkles-20240206-a0fe99b/index.html?artifacts=%7B%22light_field%22%3A%22https%3A%2F%2Fcdn-luma.com%2F5a06ec7e961f76195e648967cd20cca242ae63da33faff88fcc593b09ba20be8%2FBolbi_Gardens_Pegasus_light_field.zip%22%2C%22light_field_lf_meta%22%3A%22https%3A%2F%2Fcdn-luma.com%2Fbdf47b0bdb01b930f143387092abec0ff2b8918f169824d28681244fe71c088d%2FBolbi_Gardens_Pegasus_light_field_lf_meta.json%22%2C%22slf_model%22%3A%22https%3A%2F%2Fcdn-luma.com%2Fdeed7138ca7fee8f942b6eddea3ca3b9d7d07254476c9f5c3024cc729d4050c1%2FBolbi_Gardens_Pegasus_slf_model.luma%22%2C%22slf_model_bg%22%3A%22https%3A%2F%2Fcdn-luma.com%2Ffe07e9ce18cd1026519d67b05f2e0bd12e5c2b1762a5704cabf1d81a9e8ad059%2FBolbi_Gardens_Pegasus_slf_model_bg.luma%22%2C%22volume_model%22%3Anull%2C%22showBGByDefault%22%3Afalse%2C%22with_background%22%3A%22https%3A%2F%2Fcdn-luma.com%2F9fd2cd463b1e2e9df9014746ddb4cc97a530966b138a7602724eef4050fd77a5%2FBolbi_Gardens_Pegasus_with_background.mp4%22%2C%22with_background_preview%22%3A%22https%3A%2F%2Fcdn-luma.com%2Fd5721c9faef7bad16b3fc65c778d792c878b3534c6fa8c7d3944b582b1f0f313%2FBolbi_Gardens_Pegasus_with_background_preview.jpg%22%2C%22capture_meta%22%3A%7B%22date%22%3A%222024-05-05T15%3A00%3A00.000Z%22%2C%22title%22%3A%22Bolbi%20Gardens%20Pegasus%22%2C%22thumb%22%3A%22https%3A%2F%2Fcdn-luma.com%2F57a93438ba5e0825b39d941713a0d996d84265b081b44466f9d9337409c355da%2FBolbi_Gardens_Pegasus_thumb.jpg%22%2C%22slug%22%3A%2240a86b95-a917-4b61-bd1a-4f3ac33ca7d7%22%2C%22username%22%3A%22SonnyC56%22%2C%22captureName%22%3A%22Bolbi%20Gardens%20Pegasus%22%2C%22uuid%22%3A%2240a86b95-a917-4b61-bd1a-4f3ac33ca7d7%22%2C%22upgrade%22%3A%7B%22available%22%3Afalse%7D%7D%2C%22point_cloud%22%3Anull%2C%22gs_web_meta%22%3Anull%2C%22gs_web_gauss1%22%3Anull%2C%22gs_web_gauss2%22%3Anull%2C%22gs_web_webmeta%22%3Anull%2C%22gs_compressed%22%3A%22https%3A%2F%2Fcdn-luma.com%2F6c2c7d5d38bd809cf305d479273be305af313ab8c2a22f549078ae2714bb5365%2FBolbi_Gardens_Pegasus_gs_compressed.bin%22%2C%22gs_compressed_meta%22%3A%22https%3A%2F%2Fcdn-luma.com%2Fa9c5a4d1fa95493272611a2baf73136a695661e65552450288acf838682f93e5%2FBolbi_Gardens_Pegasus_gs_compressed_meta.json%22%2C%22with_background_gs_camera_params%22%3A%22https%3A%2F%2Fcdn-luma.com%2Fb6bf4ec45b8a28ece9a168584085ad2542df79d3bbdfb2b0372dae6d9f0df514%2FBolbi_Gardens_Pegasus_with_background_gs_camera_params.json%22%2C%22semantics%22%3A%22https%3A%2F%2Fcdn-luma.com%2Fee9e4d0ef686b441d4183ddb007e2686f02981082ee9bb6251ce608815f3c8e7%2FBolbi_Gardens_Pegasus_semantics.bin%22%2C%22skybox%22%3A%22https%3A%2F%2Fcdn-luma.com%2Fdd70af7ae9982c101915058d7868699da747e882b44910204db33a6b308cf13c%2FBolbi_Gardens_Pegasus_skybox.jpg%22%2C%22skybox_meta%22%3A%22https%3A%2F%2Fcdn-luma.com%2Ffa432dc51f1115d4997755dcd27044d8d1a528f01949c2ca3e41b7d1d50b91d5%2FBolbi_Gardens_Pegasus_skybox_meta.json%22%7D&src=undefined",
    description: "View my collection of Gaussian Splats created via Luma Labs.",
    link: "/gaussianSplats",
    buttonName: "View Splats",
  },
  {
    title: "360 Hemp Tour",
    img: cornellHempPreviewGif,
    description:
      "This is a tour of a Cornell University hemp growing facility used for their research. Through the use of 360 video, informational hotspot and integrated photos, the viewer in completely immersed into an unfamiliar world where they can explore freely while learning valuable and interesting information.",
    link: "https://assetts.thenewshouse.com/highstakes/panorama/output/index.html",
    buttonName: "View 360 Tour",
  },

  {
    title: "Forging Ahead With a Winter Adventure",
    img: adkGif,
    description:
      "Forging Ahead with a Winter Adventure is an immersive 360 degree tour of Old Forge, NY, which is one of the largest tourist destinations in the Adirondack State Park. This example shows the scale at which 360 tours can be created and custom added features such as a map in the top right corner, custom hotspots, and a custom user interface.",
    link: "https://thenewshouse-assets.s3.amazonaws.com/adirondacks/output/index.html",
    buttonName: "View 360 Tour",
  },
  {
    title: "Pandemic Pandemonium",
    img: PandemicPandemonium,
    description:
      "Pandemic Pandemonium is an android game developed as a fund raiser for the Boys and Girls Club of Greater Lynchburg. You play as a variety of characters as you avoid the Coronavirus and collect needed supplies like toilet paper and hand sanitizer. This was developed using Unreal Engine 4 and included in app purchases as well as in game advertisements which serve as the source of revenue for the fundraiser.",
    link: "https://play.google.com/store/apps/details?id=com.BGC.PandemicPandemonium&hl=en_US&gl=US",
    buttonName: "Download on Google Play",
  },
  {
    title: "Forces On Inclined Plane Demonstrator",
    img: ForcesJpg,
    description:
      "I created this in high school and with the help of my high school physics teacher was able to sell it through Arbor Scientific to physics teachers across the country. This engaging piece of lab equipment makes the component theory of forces a tangible reality for every student. The Forces on Inclined Plane Demonstrator allows teachers and students to engage directly with these challenging concepts. The built-in digital scale reveals how the Normal Force changes dependent upon the angle, and the spring scale hooked to the cart will demonstrate how the Downhill Parallel Force component changes as the angle of the inclined plane is varied. Great for both conceptual development and laboratory use. Teachers can vary angles and mass to provide a variety of variables. Finally, a supportive and real-world alternative to the whiteboard problems. Fun and easy to use!",
    link: "https://www.arborsci.com/collections/all/products/inclined-plane-demonstrator",
    buttonName: "Buy on Arbor Scientific",
  },
];

const contactConfig = {
  YOUR_EMAIL: "the@sonnycirasuolo.com",
  YOUR_FONE: "(315)272-6756",
  description:
    "Let's immerse your audience in a new world. Contact me to get started. ",
};

const socialprofils = {
  github: "https://github.com/SonnyC56",
  linkedin: "https://www.linkedin.com/in/cirasuolo/",
  twitter: "https://twitter.com/SCirasuolo",
  sketchfab: "https://sketchfab.com/sonnycirasuolo",
};
export {
  meta,
  dataabout,
  dataportfolio,
  worktimeline,
  yahooData,
  yahooData2,
  vis81Data,
  skills,
  services,
  introdata,
  contactConfig,
  socialprofils,
  logotext,
  gaussianSplatData,
};
